module.exports = __webpack_public_path__ + "static/media/sushi.824d5ccf.jpg";